import React from 'react'
import PropTypes from 'prop-types'
import { ListItemBase, IconWrapper, ContentWrapper } from './styles'
import IconEllipse from 'client/icons/Ellipse'

const ListItem = ({ icon, children }) => {
  const ListIcon = icon || IconEllipse

  return (
    <ListItemBase>
      <IconWrapper>
        <ListIcon />
      </IconWrapper>
      <ContentWrapper>{children}</ContentWrapper>
    </ListItemBase>
  )
}

ListItem.propTypes = {
  icon: PropTypes.instanceOf(Object),
  children: PropTypes.node.isRequired,
}

export default ListItem
